// Sentry must initialise before React renders so its instrumentation
// can wrap the global error handler.
import { Sentry, sentryEnabled } from './lib/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@fontsource-variable/inter';
import './styles/ui.css';
import './styles/mobile.css';

const Root = sentryEnabled
  ? (
    <Sentry.ErrorBoundary fallback={<FallbackUI />}>
      <App />
    </Sentry.ErrorBoundary>
  )
  : <App />;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>{Root}</React.StrictMode>
);

/**
 * Minimal fallback for catastrophic render errors. We don't try to be
 * clever here — if React crashed badly enough to hit ErrorBoundary,
 * something fundamental is broken and we just want the user to be
 * able to reload. Sentry already captured the exception.
 */
function FallbackUI() {
  return (
    <div style={{
      padding: '40px 24px', maxWidth: 480, margin: '60px auto',
      fontFamily: 'system-ui, sans-serif', textAlign: 'center',
      background: '#fff', borderRadius: 10, boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, color: '#c33', marginBottom: 12 }}>
        Something went wrong
      </h1>
      <p style={{ fontSize: 13, color: '#666', marginBottom: 20 }}>
        The page crashed. We've logged the error — please reload to try again.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          background: 'var(--brand)', color: '#fff', border: 'none',
          borderRadius: 7, padding: '10px 20px', fontSize: 14, fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Reload
      </button>
    </div>
  );
}
